import { Container, HeaderTitle, SubmitButton, EventForm } from "./style";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import { FormDataSource } from "../../util/formDataSource";
import { Left, Right } from "./style";
import { getColleague } from '../../api/colleaguesService';
import { getEvents } from "../../api/eventsService";
import { getPermissions, setUserPermission } from '../../api/permissionsService';
import { getPublications } from '../../api/magazineService';
import { ALL_MENU_ACCESS_KEYS, MENU_ACCESS_GROUPS, MenuAccessKey } from '../../util/menuAccess';

interface Props {
  inputs: FormDataSource[];
  actionMode: string;
}

export type IUploadStatus = "NO_IMAGE" | "UPLOADING" | "UPLOADED";

const EditPermission: React.FC<Props> = ({ actionMode }) => {
  const { id }: any = useParams();
  const [data, setData]: any = useState({});
  const [eventIds, setEventIds] = useState<number[]>([]);
  const [publicationIds, setPublicationIds] = useState<number[]>([]);
  const [menuItems, setMenuItems] = useState<MenuAccessKey[]>(ALL_MENU_ACCESS_KEYS);
  const [events, setEvents] = useState<any[]>([]);
  const [publications, setPublications] = useState<any[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    getEvents().then(setEvents).catch((err) => console.log(err.message));
    getPublications().then(setPublications).catch((err) => console.log(err.message));

    getPermissions().then((items: any) => {
      const row = items.find((item: any) => String(item.user_id) === String(id));
      if (row) {
        setEventIds((row.events || []).map(Number));
        setPublicationIds((row.publications || []).map(Number));
        setMenuItems(Array.isArray(row.menu_items) ? row.menu_items : ALL_MENU_ACCESS_KEYS);
      }
    }).catch((err: any) => console.log(err.message));

    if (actionMode === 'edit') {
      getColleague(id).then(setData).catch((err) => console.log('error', err.message));
    }
  }, [actionMode, id]);

  const handleSubmit = async (e: React.FormEvent<HTMLElement>) => {
    e.preventDefault();
    try {
      await setUserPermission(id, { events: eventIds, publications: publicationIds, menu_items: menuItems });
      navigate('/permissions');
    } catch (error: any) {
      console.log(error.message);
    }
  };

  const toggleId = (list: number[], setList: (v: number[]) => void, rawId: string, checked: boolean) => {
    const numId = Number(rawId);
    if (checked) setList([...list, numId]);
    else setList(list.filter((item) => item !== numId));
  };

  return (
    <Layout>
      <HeaderTitle>User access — events, publications &amp; menu</HeaderTitle>
      <EventForm onSubmit={(e: any) => handleSubmit(e)}>
        <Container>
          <Left>
            <div>
              <div>
                <label className="inputTitle">User Name</label> <br />
                <p>{data.username}</p>
              </div><br />
              <div>
                <label className="inputTitle">Email</label> <br />
                <p>{data.email}</p>
              </div>
              <div style={{ marginTop: 12 }}>
                <label className="inputTitle">Role</label> <br />
                <p>{data.role_title || data.role || '—'}</p>
              </div>
              <SubmitButton type="submit" className="submit">
                Save access
              </SubmitButton>
            </div>
          </Left>
          <Right>
            <div className="checkboxs" style={{ display: 'flex', gap: 32, flexWrap: 'wrap' }}>
              <div>
                <h3 style={{ marginBottom: 8, fontSize: 16 }}>Events</h3>
                {!events.length && <p style={{ color: '#666', fontSize: 14 }}>No events available.</p>}
                {events?.map((event: any) => (
                  <div key={event.id} className="event">
                    <input
                      type="checkbox"
                      id={`event_${event.id}`}
                      checked={eventIds.includes(Number(event.id))}
                      onChange={(e) => toggleId(eventIds, setEventIds, String(event.id), e.target.checked)}
                    />
                    <label className="eventTitle" htmlFor={`event_${event.id}`}>{event.title}</label>
                  </div>
                ))}
              </div>
              <div>
                <h3 style={{ marginBottom: 8, fontSize: 16 }}>Magazine publications</h3>
                {!publications.length && <p style={{ color: '#666', fontSize: 14 }}>No publications available.</p>}
                {publications?.map((pub: any) => (
                  <div key={pub.id} className="event">
                    <input
                      type="checkbox"
                      id={`pub_${pub.id}`}
                      checked={publicationIds.includes(Number(pub.id))}
                      onChange={(e) => toggleId(publicationIds, setPublicationIds, String(pub.id), e.target.checked)}
                    />
                    <label className="eventTitle" htmlFor={`pub_${pub.id}`}>{pub.name}</label>
                  </div>
                ))}
              </div>
              <div>
                <h3 style={{ marginBottom: 8, fontSize: 16 }}>Menu access</h3>
                {MENU_ACCESS_GROUPS.map((group) => (
                  <div key={group.label} style={{ marginBottom: 16 }}>
                    <strong style={{ display: 'block', marginBottom: 6, fontSize: 14 }}>{group.label}</strong>
                    {group.items.map((item) => (
                      <div key={item.key} className="event">
                        <input
                          type="checkbox"
                          id={`menu_${item.key}`}
                          checked={menuItems.includes(item.key)}
                          onChange={(e) => setMenuItems(e.target.checked
                            ? [...menuItems, item.key]
                            : menuItems.filter((key) => key !== item.key))}
                        />
                        <label className="eventTitle" htmlFor={`menu_${item.key}`}>{item.label}</label>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </Right>
        </Container>
      </EventForm>
    </Layout>
  );
};

export default EditPermission;
